import { fdCarouselContent } from '@components/Products/FixedDeposits/utils/helper';
import { Text } from '@ui/atoms';
import FDCarousels from '@components/Products/FixedDeposits/components/Carousel/FDCarousels';

const FixedDepositsCarousel = ({ fixedDepositBanks, toggleModal }) => {
    return (
        <section className="w-full max-w-[400px] mx-auto md:max-w-none py-10 md:px-4">
            <div className="flex flex-col gap-2 md:gap-4">
                <Text
                    content={fdCarouselContent.title}
                    className="text-center p3-regular md:h3-regular text-basicBlack"
                    isInnerHtml
                    htmlTag="h2"
                />
                <Text
                    content={fdCarouselContent.description}
                    className="text-center text-gray-500 p5-regular md:h5-regular"
                    htmlTag="p"
                />
            </div>
            <FDCarousels
                fixedDepositBanks={fixedDepositBanks}
                toggleModal={toggleModal}
            />
        </section>
    );
};

export default FixedDepositsCarousel;
